<script>
  import Router from "svelte-spa-router";
  import { link } from "svelte-spa-router";
  import { supabase } from "./auth";
  import active from "svelte-spa-router/active";
  import Sidebar from "./components/Sidebar.svelte";
  import Community from "./pages/Community/Community.svelte";
  import Vereinsheim from "./pages/Community/Vereinsheim.svelte";
  import Signin from "./pages/Signin.svelte";
  import NotFound from "./pages/NotFound.svelte";
  import Profile from "./pages/Profile/Profile.svelte";
  import TacticalView from "./pages/TacticalView/TacticalView.svelte";
  import Calendar from "./pages/Calendar.svelte";
  import Messages from "./pages/Messages.svelte";
  import LoadingScreen from "./components/LoadingScreen.svelte";

  const routes = {
    "/": Profile,
    "/community": Community,
    "/community/vereinsheim": Vereinsheim,
    "/tactical": TacticalView,
    "/calendar": Calendar,
    "/messages": Messages,
    "*": NotFound,
  };

  let authState = "Loading";
  authState = supabase.auth.user();

  supabase.auth.onAuthStateChange((event) => {
    authState = supabase.auth.user();
  });
</script>

{#if authState == "Loading"}
  <LoadingScreen />
{:else if authState}
  <Sidebar class="z-50">
    <span class="flex flex-col mt-40 text-left" slot="sidebar">
      <a href="/" class="navitem" use:link use:active>🧑‍🚀 Profil</a>
      <a href="/community" class="navitem" use:link use:active>🤙 Community</a>
      <a href="/tactical" class="navitem" use:link use:active
        >📲 Tactical View</a
      >
      <a href="/calendar" class="navitem" use:link use:active>📆 Kalender</a>
      <a href="/messages" class="navitem" use:link use:active>🗣 Nachrichten</a>
    </span>
    <span slot="content">
      <Router {routes} />
    </span>
  </Sidebar>
{:else}
  <Signin />
{/if}

<style>
  :global(.navitem.active) {
    border: 2px solid #ed1c24;
    border-radius: 0.375rem;
  }

  .navitem {
    padding: 0.5rem;
  }
</style>
